




























































import { computed, defineComponent } from "@vue/composition-api";
import { UserVerificationStatus } from "@scrile/api-provider/dist/api/UserVerificationProvider";
import { ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import config from "@/config";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "ChoosePostType",
  components: { PageTitle, BaseButton, BaseIcon, BaseConfirm },
  props: {
    showChooseType: { type: Boolean, required: true },
    userId: { type: String, required: true },
    onlyLivesAllowed: { type: Boolean, default: false },
  },
  setup() {
    const { authUser, authorities, isCreator, userVerificationStatus } = useAuthUser();
    const isVerifiedCreator = computed(
      () => isCreator.value && userVerificationStatus.value === UserVerificationStatus.VERIFIED
    );
    return {
      authUser,
      authorities,
      isVerifiedCreator,
    };
  },
  data() {
    return {
      contentTypeEnum: ContentFeedTypeEnum,
      processingType: null as ContentFeedTypeEnum | null,
    };
  },
  computed: {
    isAuthor(): boolean {
      return this.authUser?.id === this.userId;
    },
    canCreateEvent(): boolean {
      return checkAuthorities(
        this.authorities,
        this.isAuthor ? ["updateMyEvent", "getMyEvent"] : ["updateAnyEvent", "getAnyEvent"]
      );
    },
    featureStories() {
      return config.featureStories;
    },
    featureTextPosts() {
      return config.featureTextPosts;
    },
    featureEvents() {
      return config.featureEvents && this.canCreateEvent;
    },
    featureGoLive(): boolean {
      return config.featureGoLive;
    },
    allowStreaming(): boolean {
      return checkAuthorities(this.authorities, ["havePublicLivechat"]) && this.featureGoLive && this.isVerifiedCreator;
    },
    onlyPostsAllowed() {
      return !this.featureEvents && !this.featureStories && !this.allowStreaming && !this.featureTextPosts;
    },
  },
  methods: {
    selectType(type: ContentFeedTypeEnum) {
      if (this.processingType) {
        return;
      }
      this.processingType = type;
      this.$emit("selectType", type, () => (this.processingType = null));
    },
  },
  created() {
    if (this.onlyPostsAllowed) {
      this.processingType = ContentFeedTypeEnum.MEDIA;
      this.$emit("selectType", ContentFeedTypeEnum.MEDIA, () => (this.processingType = null));
    }
  },
});
